import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isPageLoading, setIsPageLoading] = useState(false); // Start with false to prevent blank page
  const [isNavigating, setIsNavigating] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const location = useLocation();

  // Handle route changes (navigation between pages)
  useEffect(() => {
    setIsNavigating(true);
    setIsPageLoading(true);
    
    const timer = setTimeout(() => {
      setIsNavigating(false);
      setIsPageLoading(false);
    }, 200); // Reduced timeout for faster response

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Handle browser back/forward navigation
  useEffect(() => {
    const handlePopState = () => {
      setIsNavigating(true);
      setIsPageLoading(true);
      
      setTimeout(() => {
        setIsNavigating(false);
        setIsPageLoading(false);
      }, 200);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const value = {
    isPageLoading,
    isNavigating,
    isRefreshing,
    setIsPageLoading,
    setIsNavigating,
    setIsRefreshing
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};